// Test IDs for the Daddy Of AI dashboard (Phase 3A)
export const AUREUS = {
  // Landing
  landingHero:        "landing-hero",
  landingCtaPrimary:  "landing-cta-primary",
  landingCtaSecondary:"landing-cta-secondary",
  landingEngineGrid:  "landing-engine-grid",
  landingEngineTile:  (id) => `landing-engine-tile-${id}`,

  // Sidebar
  sidebar:            "sidebar",
  sidebarLogo:        "sidebar-logo",
  navHome:            "nav-home",
  navEngines:         "nav-engines",
  navAlerts:          "nav-alerts",
  navTimeline:        "nav-timeline",
  navHistory:         "nav-history",
  navSettings:        "nav-settings",
  navLanding:         "nav-landing",

  // Multi-pair dashboard
  multiPairGrid:      "multi-pair-grid",
  pairCard:           (sym) => `instrument-card-${sym.toUpperCase()}`,
  pairCardPrice:      (sym) => `instrument-card-price-${sym.toUpperCase()}`,
  pairCardBias:       (sym) => `instrument-card-bias-${sym.toUpperCase()}`,
  pairCardScore:      (sym) => `instrument-card-score-${sym.toUpperCase()}`,

  // Single-pair detail
  detailRoot:         "detail-root",
  topStrip:           "top-strip",
  topStripSession:    "top-strip-session",
  topStripCountdown:  "top-strip-countdown",
  topStripKillzone:   "top-strip-killzone",
  topStripRisk:       "top-strip-risk",
  topStripScore:      "top-strip-score",
  topStripBias:       "top-strip-bias",

  pressureCard:       "pressure-card",
  pressureBullish:    "pressure-bullish",
  pressureBearish:    "pressure-bearish",

  tradeBrief:         "trade-brief",
  tbPrice:            "tb-price",
  tbTier:             "tb-tier",
  tbDowngrade:        "tb-downgrade",
  tbEntry:            "tb-entry",
  tbRisk:             "tb-risk",
  tbT1:               "tb-t1",
  tbT2:               "tb-t2",
  tbWhy:              "tb-why",

  smcBox:             "smc-box",
  smcChip:            (id) => `smc-chip-${id.toLowerCase()}`,

  liquidityMap:       "liquidity-map",
  liquidityLevel:     (kind) => `liquidity-level-${kind.toLowerCase()}`,

  scenarioMap:        "scenario-map",
  scenarioPrimary:    "scenario-primary",
  scenarioAlt:        "scenario-alt",

  entryZones:         "entry-zones",
  entrySniper:        "entry-sniper",
  entryScalp:         "entry-scalp",

  // Engines page
  enginesPage:        "engines-page",
  engineCard:         (id) => `engine-card-${id}`,

  // Phase 3B
  modeToggle:         "mode-toggle",
  modeToggleSnipe:    "mode-toggle-snipe",
  modeToggleScalp:    "mode-toggle-scalp",

  timelinePage:       "timeline-page",
  timelineFilters:    "timeline-filters",
  timelineEvent:      (id) => `timeline-event-${id}`,

  // Phase 3B
  historyPage:        "history-page",
  historyFilters:     "history-filters",
  historyRangeBtn:    (range) => `history-range-${range}`,
  historySymbolBtn:   (sym)   => `history-symbol-btn-${sym.toUpperCase()}`,
  historyStatsCard:   "history-stats-card",
  historyWinRate:     "history-win-rate",
  historyAvgRR:       "history-avg-rr",
  historyTotal:       "history-total",
  historyRow:         (id) => `history-row-${id}`,

  // Phase 3C
  alertsPage:         "alerts-page",
  alertsFilters:      "alerts-filters",
  alertsFilterBtn:    (f) => `alerts-filter-${f}`,
  alertsMarkAll:      "alerts-mark-all",
  alertRow:           (id) => `alert-row-${id}`,
};
